import styled from "styled-components";
import { Device } from "../../styles/screenSizes";
import { colors } from "../../styles/variables";

export const StyledContent = styled.div`
  background-color: ${({ theme }) =>
    theme.footer?.backgroundColor || theme.color.primary};
  color: ${({ theme }) => theme.footer?.textColor || colors.white};
  height: auto;
  padding: 60px 80px 80px 60px;

  a {
    color: ${({ theme }) => theme.footer?.textColor || colors.white};
    text-decoration: none;
  }

  @media ${Device.mobile} {
    padding: 40px 40px 80px;
  }
`;

export const StyledBrandingAndNav = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  @media ${Device.notLaptop} {
    flex-direction: column-reverse;
    align-items: flex-start;
  }
`;
